import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types

export type Parceiro = {
    ownerId: string
    nome: string
    email: string
    telefone?: string
}

export type LoteStatus = 'pendente' | 'processando' | 'concluido' | 'cancelado' | 'erro'

export type Lote = {
    id: string
    ownerId: string
    ownerNome: string
    ownerEmail: string
    solicitante?: string
    status: LoteStatus
    total: number
    processados: number
    cadastrados: number
    erro?: string
    createdAt: Date
    startedAt?: Date
    finishedAt?: Date
}

export type LoteItem = {
    seq: number
    cnpj: string
    status: string
    razaoSocial?: string
    dealId?: string
    mensagem?: string
    processedAt?: Date
}

export type LoteDetalhe = Lote & {
    itens: LoteItem[]
    resumo: { status: string; qtde: number }[]
}

/** Resultado da conferência do texto colado, antes de disparar o lote. */
export type PreviaCnpjs = {
    validos: string[]
    invalidos: string[]
    duplicados: string[]
}

// :: Scopes

@Observable
export class CadastroLoteScope extends Scope {
    // Formulário
    @observe() parceiros: Parceiro[] = []
    @observe() parceiroSelecionado?: Parceiro
    @observe() buscaParceiro = ''
    @observe() carregandoParceiros = false
    @observe() textoCnpjs = ''
    @observe() previa?: PreviaCnpjs
    @observe() confirmacaoAberta = false
    @observe() enviando = false
    @observe() erroFormulario?: string

    // Acompanhamento
    @observe() lote?: LoteDetalhe
    @observe() carregandoLote = false
    @observe() baixandoCsv = false

    // Histórico
    @observe() historico: Lote[] = []
    @observe() carregandoHistorico = false

    onSelecionarParceiro = Scope.ASYNC_ACTION_ONE<Parceiro | undefined>()
    onBuscarParceiro = Scope.ASYNC_ACTION_STRING
    onTextoCnpjsChange = Scope.ASYNC_ACTION_STRING
    onConferir = Scope.ASYNC_ACTION
    onFecharConfirmacao = Scope.ASYNC_ACTION
    onConfirmarDisparo = Scope.ASYNC_ACTION
    onCancelarLote = Scope.ASYNC_ACTION
    onBaixarCsv = Scope.ASYNC_ACTION
    onAbrirLote = Scope.ASYNC_ACTION_ONE<string>()
    onNovoLote = Scope.ASYNC_ACTION
}
